import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SettingsPlanFreePage } from './settings-plan-free';

@NgModule({
  declarations: [
    SettingsPlanFreePage
  ],
  imports: [
    IonicPageModule.forChild(SettingsPlanFreePage)
  ]
})
export class SettingsPlanFreePageModule {}



// WEBPACK FOOTER //
// ./src/pages/settings-plan-free/settings-plan-free.module.ts